import axios from "axios";
import authHeader from "@/services/auth.header";
import { HTTP } from "@/http/config";
import { AnyObject } from "yup";
const API_URL = HTTP.api_url;
class DiagnostService {
  async getIndex(): Promise<AnyObject> {
    const response = await axios
      .get(API_URL + "diagnosts", { headers: authHeader() })
      .then((response) => {
        //console.log(JSON.stringify(response.data.data))
        return response.data;
      })
      .catch((error) => {
        const dataError = JSON.stringify(error.response.data);
        console.log(dataError);
      });
    return response;
  }
  async getSearch(search): Promise<AnyObject> {
    const response = await axios
      .get(API_URL + `diagnosts`, {
        params: search,
        headers: authHeader(),
      })
      .then((response) => {
        //console.log(JSON.stringify(response.data.data))
        return response.data;
      })
      .catch((error) => {
        const dataError = JSON.stringify(error.response.data);
        console.log(dataError);
      });
    return response;
  }
  async getlist(pageNumber): Promise<AnyObject> {
    const response = await axios
      .get(API_URL + `diagnosts?page=${pageNumber}`, { headers: authHeader() })
      .then((response) => {
        //console.log(JSON.stringify(response.data.data))
        return response.data;
      })
      .catch((error) => {
        const dataError = JSON.stringify(error.response.data);
        console.log(dataError);
      });
    return response;
  }

  async postCreated(diagnosts): Promise<AnyObject> {
    const response = await axios
      .post(API_URL + "diagnosts", diagnosts, { headers: authHeader() })
      .then((response) => {
        // console.log(response.data)
        return response.data;
      })
      .catch((error) => {
        const dataError = error.response.data;
        console.log(dataError);
        return dataError;
      });
    return response;
  }

  async postUpdate(id, diagnosts): Promise<AnyObject> {
    const response = await axios
      .put(
        API_URL + `diagnosts/${id}`,
        { id: Number(id), ...diagnosts },
        { headers: authHeader() },
      )
      .then((response) => {
        //console.log(response.data)
        return response?.data;
      })
      .catch((error) => {
        const dataError = error.response.data;
        console.log(dataError);
        return dataError;
      });
    return response;
  }
  async getEdit(id): Promise<AnyObject[]> {
    const response = await axios
      .get(API_URL + `diagnosts/${id}`, { headers: authHeader() })
      .then((response) => {
        return response?.data;
      })
      .catch((error) => {
        const dataError = error.response.data;
        console.log(dataError);
        return dataError;
      });
    return response;
  }

  async getDelete(id): Promise<AnyObject> {
    const response = await axios
      .delete(API_URL + `diagnosts/${id}`, { headers: authHeader() })
      .then((response) => {
        return response?.data;
      })
      .catch((error) => {
        const dataError = error.response.data;
        console.log(dataError);
        return dataError;
      });
    return response;
  }

  async getListDiagnost(): Promise<AnyObject> {
    const response = await axios
      .get(API_URL + "diagnosts/list-diagnost", { headers: authHeader() })
      .then((response) => {
        //console.log(JSON.stringify(response.data.data))
        return response.data.data;
      })
      .catch((error) => {
        const dataError = JSON.stringify(error.response.data);
        console.log(dataError);
      });
    return response;
  }
}
export default new DiagnostService();
